// Sortable
import { moveItemInList } from 'mdb-sortable';
// tables
import {
  Component, OnInit, ElementRef, HostListener,
  AfterViewInit, ViewChild, ChangeDetectorRef,
  QueryList, ViewChildren, Input, Output, EventEmitter
} from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, MdbBtnDirective, MDBModalRef } from 'ng-uikit-pro-standard';
// mensage type  toast
import { ToastService } from 'ng-uikit-pro-standard';
// forms and validations
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ComponentsType, ComponentIndicator, ComponentChart, ChartDatasets, ChartColors, Dashboard } from 'src/app/models/component-data';
import { DasboardService } from 'src/app/services/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { GetTypePipe } from 'src/app/custom-pipe/GetTypePipe';
import { AppConfigService } from 'src/app/app-config.service.service';
import { ProjectService } from 'src/app/services/project.service';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/services/general.service';
import { Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';

@Component({
  selector: 'alarm-work-flow-summary',
  templateUrl: './alarm-work-flow-summary.component.html',
  styleUrls: ['./alarm-work-flow-summary.component.scss']
})
export class AlarmWorkFlowSummaryComponent implements OnInit {
  @Input() PopupAlarm: any;
  @Output() CerrarModal = new EventEmitter<any>();
  dateFormat = 'dd-MM-yyyy';
  moneyFormat = '';
  dateFormat1: any
  // PopupAlarm: boolean = false
  PhasesAlarm: any[] = []
  customOperations: Array<any>;
  popupPosition: any;
  TotalAlarms: number = 0
  statusList: any[] = []



  constructor(
    private ProjectService: ProjectService,
    private datePipe: DatePipe,
    private translate:TranslateService,
    private translateService: TranslateService,
    // private translatePipe: TranslatePipe,
    private appConfigService: AppConfigService,
    public generalService: GeneralService,
    private toast: ToastService,
    private router: Router,
    public MapInformationService: MapInformationService,
  ) {

    this.dateFormat = this.appConfigService.dateFormat;
    this.dateFormat1 = this.appConfigService.dateFormat;
    this.moneyFormat = this.appConfigService.moneyFormat;

  }

  ngOnInit() {
    this.getAlarms()
  }

  getAlarms() {
    const data = {
      method: "Get_ProjectWorkFlowAlarms"
    }
    this.ProjectService.GetStatusList().subscribe(result => {
      this.statusList = result.map((val, id) => {
        return {
          id: id + 1,
          name: val.WFSTATUSNAME
        }
      })
      console.log(this.statusList)
      this.MapInformationService.SaveInfoSites(data)
        .subscribe(resp => {
          this.ProjectService.Get_ProjectPhasesCE()
            .subscribe(info => {

              // for (let i = 0; i < resp.length; i++) {
              //   for (let j = 0; j < info.length; j++) {
              //     if (resp[i].WF_PhaseId == info[j].ID) {
              //       resp[i].SORT = info[j].SORT
              //     }
              //   }
              // }
              console.log(resp)
              resp.sort(function (a, b) { return a.Flow_Sort - b.Flow_Sort })
              console.log(resp)
              let infoFinal = []
              if(resp.length > 0){
                resp.forEach(element => {
                  if(element.Flow_Active){
                    element.Flow_ActiveYesOrNo = "Yes"
                  } else {
                    element.Flow_ActiveYesOrNo = "No"
                  }
                  infoFinal.push(element)
                });
              }
              // this.PhasesAlarm = resp
              this.PhasesAlarm = infoFinal
              this.TotalAlarms = resp.length
            })
        })
    })
  }

  CloseModal() {
    this.PopupAlarm = false
    this.CerrarModal.emit(false)
  }

  saveStatusWorkFlow(e) {
    console.log(e)
    let data = e.data;
    let project = {
      id: data.ID,
      projectid: data.Project_Id,
      workflowstatusid: data.PhaseStatus_Id,
      notes: "",
    }
    console.log(project)
    this.ProjectService.UpdateProjectWorkFlow(project).subscribe(result => {
      this.toast.success(this.translate.instant('msgProjWorUpdSucc'));
      this.getAlarms()
    })
  }
}
